<template>
  <div class="commonLiStyle">
    <top-component></top-component>
    <!-- <div class="bannerFirst" @click="ComeLive"></div> -->
    <div class="commonLiContainer">
      <MyAside></MyAside>
      <div class="commontent">
        <div class="titleMap">AI体温检测系统</div>
        <div class="letterTitle">2020/4/12 23:00</div>
        <img src="../../assets//images/AI-1.png">
        <div class="threediv">依迅北斗+AI 体温检测系统</div>
        <div class="threediv">
          1.产品简介
        </div>
        <div class="threediv">
          依迅北斗+AI 体温检测系统是一款专业体温检测与智能人脸识别一体化的产品， 可实现智能体温测温、是否佩戴口罩检测、无需接触，开机即用，使用体验更快更精准，室内外环境通用，可固定桌面安装、可挂墙安装、可车载安装。
        </div>
        <div class="threediv">
          2.产品特点
        </div>
        <div class="threediv">
          2.1高精度红外人体测温
        </div>
        <div class="threediv">
          德国海曼 32x32 红外测温模块，测温传感器精度高；测温误差≤±0.3℃，测温速度 0.1 秒，检测距离 0.5 米；医疗级人体测温算法。
        </div>
        <div class="threediv">
          2.2智能人脸识别与提醒
        </div>
        <div class="threediv">
          标配 10000 人脸存储，最多支持 50000 张人脸库；支持戴帽、戴眼镜人脸考勤与测温提醒；高可靠、毫秒级人脸分析算法，口罩佩戴防护提醒；支持强逆光模式，支持双目活体检测，支持 OTC
          远程程序升级。“测温、扫码、人脸识别”三项防疫监测工作一次完成，无需人员手工操作与记录，监测数据实时导出。
        </div>
        <div class="threediv">
          2.3支持快速部署可扩展 5G+北斗
        </div>
        <div class="threediv">
          国内首创将北斗时空位置信息与测温设备相结合，定点定位采集防数据作弊。将测温设备、健康码绑定地理坐标，真正做到测温、健康码扫码位置可追溯，堵塞监管漏洞。车载环境下可满足公安部、交通部相关国家标准数据可靠可信度高。设备高度集成化、体积小、通电即用，便于快速实施部署；可扩展支持
          4G/5G，标配 Wi-fi/RJ/RS 等多网络远程方式便管理。
        </div>
        <div class="threediv">
          2.4智能监管平台与上报
        </div>
        <div class="threediv">
          自主可控人工智能自学习核心算法，可无障碍对接智慧社区、平安校园、智慧城管、平安城市、车站进站管理、产业园区管控、物业管理、考勤管理、OA 系统、ERP
          系统等各类平台系统；支持校车、公交、地铁、大巴、包车等车辆开关控制与政府监管平台上报。
        </div>
        <div class="threediv">
          2.5丰富接口
        </div>
        <div class="threediv">
          物联网接口灵活方便，即插即用可控制各单位原有门禁、道闸、停车场抬杆等，可考勤、监测、云端追溯，打造了非接触式“防控、测温、留痕”的防疫新模式。社区、企业、商业体、学校、机关等多场景适配，便于大规模推广。
        </div>
        <div class="threediv">
          3.技术参数
        </div>
        <table>
          <tr>
            <td>名 称</td>
            <td>功能描述</td>
          </tr>
          <tr>
            <td>CPU</td>
            <td>四核 Cortex-A17，高性能 28nm HKMG 工艺</td>
          </tr>
          <tr>
            <td>GPU</td>
            <td>Mali-T764 GPU, 支持 AFBC( 帧缓冲 压缩） , 支持 OpenGL ES 1.1/2.0/3.1, 内嵌高性能 2D 加速硬件 OpenCL, DirectX9.3</td>
          </tr>
          <tr>
            <td>内存</td>
            <td>DDR3 2G</td>
          </tr>
          <tr>
            <td>存储容量</td>
            <td>eMMC 8GB</td>
          </tr>
          <tr>
            <td>显示屏</td>
            <td>MIPI 接口；1280*800</td>
          </tr>
          <tr>
            <td>人体测温</td>
            <td>高精度测温，误差理论值在±0.2°</td>
          </tr>
          <tr>
            <td>网络</td>
            <td>具备百兆网口，支持 Ethernet支持 2.4G WiFi，Wi-Fi 支持 802.11b/g/n 协议。具备蓝牙功能 V2.1+EDR/Bluetooth3.0/3.0+HS/4.0</td>
          </tr>
          <tr>
            <td>摄像头</td>
            <td>双 200W 摄像头（RGB+IR），高亮红外补光灯</td>
          </tr>
          <tr>
            <td>实时时钟</td>
            <td>内置实时时钟供电电池</td>
          </tr>
          <tr>
            <td>外设</td>
            <td>支持 1 路 485 支持 1 路 RJ45 以太网接口 支持 2 路继电器（默认 Open）支持 2 个 USB HOST 内置双喇叭 3W*4R</td>
          </tr>
          <tr>
            <td>输入适配器</td>
            <td>输入：AC100-240V.50-60HZ 输出： DC12V/5.5mm 内芯 2.1 mm DC 头 2A－5A （要求浪涌电压小于 18V，纹波电压小于 100mV）：上电自启动</td>
          </tr>
        </table>
        <div class="threediv">
          4.软件说明
        </div>
        <table>
          <tr>
            <td>软件项</td>
            <td>详细内容</td>
          </tr>
          <tr>
            <td>操作系统</td>
            <td>默认 Android 5.1</td>
          </tr>
          <tr>
            <td>基本软件功能</td>
            <td>相机，网页浏览、资源管理器</td>
          </tr>
          <tr>
            <td>音效模式</td>
            <td>时钟、闹钟、录音</td>
          </tr>
          <tr>
            <td>语言支持</td>
            <td>中文、英语、德语、法语、日语、俄语、希腊语、拉丁语等</td>
          </tr>
          <tr>
            <td>录音</td>
            <td>支持 MP3、WMA 格式录音</td>
          </tr>
          <tr>
            <td>文书处理</td>
            <td>EPUB/WORD/EXCEL/POWERPOINT/PDF/TXT</td>
          </tr>
          <tr>
            <td>电子书</td>
            <td>PDF/TXT/CHM/DOC/EXCEL/EPUB/RTF/FB2</td>
          </tr>
          <tr>
            <td>日程</td>
            <td>日历</td>
          </tr>
          <tr>
            <td>输入法</td>
            <td>标准 Andriod 键盘，可选第三方输入法（中文、韩文、日文等</td>
          </tr>
          <tr>
            <td>软件信息</td>
            <td>百度人脸识别离线 SDK 4.0 系列 SDK原生态 Android 系统，可开放 root 权限，可软件定制开发APK 安装器；System Setting</td>
          </tr>
        </table>
        <div class="threediv">
          5.标配接口说明
        </div>
        <img src="../../assets/images/AI-2.jpg">
        <div class="threediv">
          12V 电源 4 路继电器控制 485 接口 USB（主\从） USB（主\从） RJ45 网络接口
        </div>
        <div class="threediv">
          6. 包装配件说明
        </div>
        <div class="threediv">
          6.1 产品包装盒（一台独立包装）
        </div>
        <div class="threediv">
          6.2 依迅北斗+AI 体温检测终端主机一台
        </div>
        <div class="threediv">
          6.3 立柱支架或者壁挂支架（请与客户确认安装方式）
        </div>
        <div class="threediv">
          6.4 12V 电源一个
        </div>
        <div class="threediv">
          7. 安装调试说明
        </div>
        <div class="threediv">
          7.1 产品外观特性
        </div>
        <img src="../../assets/images/AI-3.jpg">
        <div class="threediv">
          7.2 设置界面
        </div>
        <img src="../../assets/images/AI-4.jpg">
        <div class="threediv">
          点击右上角“设置按钮”进入“注册人脸”，输入姓名和 ID 后，将脸对准镜头采集脸谱
        </div>
        <div class="threediv">
          7.3 距离太远提示
        </div>
        <img src="../../assets/images/AI-5.jpg">
        <div class="threediv">
          本产品测温模块有效距离为 50CM 以内，当距离太远时会提示“请靠近一点”
        </div>
        <div class="threediv">
          7.4 开始使用
        </div>
        <img src="../../assets/images/AI-6.jpg">
        <div class="threediv">
          实时检测，是否佩戴口罩检测，是否允许通行
        </div>
        <div class="threediv">
          7.5 导入企业健康码
        </div>
        <div class="threediv">
          将微信/支付宝“企业健康码”图片放置 U 盘根目录下 heather 文件夹，二维码名称命名为 “code1.png”、”code2.png”(可放入 2 张，按顺序依次导入)
        </div>
        <img src="../../assets/images/AI-7.jpg">
        <div class="threediv">
          将 U 盘插入“未标明 OTG”标签的 USB 接口，开机启动状态下可自动导入到设备。
        </div>
        <img src="../../assets/images/AI-8.jpg">
      </div>
    </div>
    <bottom-component></bottom-component>
  </div>
</template>

<script>
  import BottomComponent from '../Components/BottomComponent.vue'
  import TopComponent from '../Components/TopComponent.vue'
  import MyAside from '@/components/MyAside.vue'
  export default {
    name: 'SchoolLibrary',
    data() {
      return {
      }
    },
    mounted() {
    },
    methods: {
      // 进入直播
      ComeLive() {
        // 1、后台如果设置了默认直播，就传过去默认直播的id，否则就传0
        // 2、HomePage: true; 用来判断是不是从首页进入的，
        // 首页进来的话，优先播放和服务器时间对的上的直播，
        // 其次是查看有没有默认直播，
        // 上面都没有满足的话就展示没有直播提醒的提示
        // 3、直播页中直接点击议程跳转到新的页面，就展示点击的议程的直播 Cookies.set('linkUrl', item.linkUrl) Cookies.get('linkUrl')
        this.$router.push({ name: 'LookLiveG', params: { webinarId: 0 } })
        Cookies.set('HomePage', true)
        Cookies.set('playType', 1)
        Cookies.set('playUrl', 'null')
      }
    },
    components: {
      BottomComponent,
      TopComponent,
      [MyAside.name]: MyAside
    },
  }
</script>

<style scoped lang="scss">
  .commonLiStyle {
    width: 100%;
    background-color: #f9f9f9;
    overflow-x: hidden;
  }

  /* banner */
  .bannerFirst {
    height: 67px;
    cursor: pointer;
    background: url('../../assets/images/NewBanner.png') no-repeat center center;
    background-size: auto 100%;
  }

  /* 公共 */
  .commonLiContainer {
    display: flex;
    justify-content: center;
    padding: 60px 50px;
    background-color: #FFDDB0;
  }

  .commontent {
    padding: 74px 100px 50px 100px;
    background-color: #fff;
    font-family: PingFang-SC-Bold;
  }

  /* title */
  .titleMap {
    color: #000;
    font-size: 40px;
  }

  .letterTitle {
    color: #333;
    font-size: 16px;
    margin-top: 10px;
    margin-bottom: 68px;
  }

  /* 1 */
  .twodiv {
    color: #333;
    font-size: 16px;
    margin-top: 10px;
    line-height: 25px;
    text-align: left;
  }

  /* 2 */
  .threediv {
    margin: 20px auto;
  }

  table {
    border-collapse: collapse;
  }

  table td {
    padding: 15px;
    border: 1px solid #000;
  }

  img {
    max-width: 100%;
    max-height: 380px;
  }
</style>



// WEBPACK FOOTER //
// src/views/ChildPages/Product-AI.vue